import { useContext, useEffect } from 'react';
import { useRouteError, Navigate } from 'react-router-dom';
import { AuthContext } from '@contexts/auth-context';
import * as Sentry from '@sentry/react';
import { parseBillingAccessError, redirectToBillingAccess } from '@services/billing-access';
import TravelErrorPanel from '@components/travel-error-panel';

function ErrorPage() {
  const error = useRouteError();
  const billingAccessPayload = parseBillingAccessError(error);

  const { isAuthenticated } = useContext(AuthContext);

  useEffect(() => {
    if (billingAccessPayload) {
      redirectToBillingAccess(billingAccessPayload);
      return;
    }

    Sentry.captureException(error, { extra: { routeError: error } });
  }, [billingAccessPayload, error]);

  if (billingAccessPayload) {
    return null;
  }

  // TODO redirect back to requested page after auth
  if (!isAuthenticated) return <Navigate to="/login" />;

  return <TravelErrorPanel />;
}

export default ErrorPage;
